import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@truevault/aquilo";
import { Api } from "../../../common/service/Api";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { PageLoading } from "../../components";

type RouteParams = {
  organizationId: string;
};

export const EventPulseLaunchPage = () => {
  const { organizationId } = useParams<RouteParams>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const launch = async () => {
      if (!organizationId) {
        setError("Missing organization id.");
        return;
      }

      try {
        const response = await Api.organization.getEventPulseLaunchUrl(organizationId);
        if (cancelled) {
          return;
        }
        window.location.assign(response.launchUrl);
      } catch (launchError) {
        if (!cancelled) {
          setError(
            launchError instanceof Error ? launchError.message : "Failed to open Event Pulse.",
          );
        }
      }
    };

    void launch();
    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  if (!error) {
    return <PageLoading />;
  }

  return (
    <StandardPageWrapper fullWidth>
      <div className="tw-boundary">
        <div className="max-w-xl rounded-md border border-red-200 bg-red-50 p-6">
          <h2 className="mb-2 text-lg font-semibold text-red-900">Unable to open Event Pulse</h2>
          <p className="mb-4 text-red-800">{error}</p>
          <Button color="primary" onClick={() => window.location.reload()}>
            Try again
          </Button>
        </div>
      </div>
    </StandardPageWrapper>
  );
};
